<div class="row wrapper border-bottom white-bg page-heading">
	<div class="col-lg-10">
		<h2>Mapa Estratégico</h2>
	</div>
	<div class="col-lg-2"></div>
</div>

<div class="bscEspecial row map-dashboard" id="mapa-estrategico">
</div>

<div class="wrapper wrapper-content animated fadeInRight">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-title">

					<div class="col-sm-7"></div>
					<div class="col-sm-5 pull-right">
						<form>
							<div class="form-group row m-b table-form">
								<div class="col-sm-12">
									<ng-select id="execution_id" class="ng-select-alternative" [items]="items_map" bindLabel="label" bindValue="value" ([ngModel])="projects" placeholder="Visualizar por" (change)="filterAgency($event)">
									</ng-select>
								</div>
							</div>
						</form>
					</div>

				</div>
				<div class="ibox-content">
					<!-- Mapa estratégico 2023 -->
					<!--  Large -->

					<div class="container large-map-2023">
						<div class="row large-map-2023">
							<div id="header_map1" class="col-md-12">
								<img class="img_header img-fluid" src="{{imagePath}}header_map1.png">
							</div>
						</div>
						<div class="row">
							<div class="col-md-12" style="position: relative;">
								<div class="perspectivas">
									<div id="header_p1" class="header_p">
										<img src="{{imagePath}}header_p1.png" class="img-fluid">
									</div>
									<div class="content_p bg_content_p1">
										<div class="tarja-left1 bg_p1">
											<img src="{{imagePath}}target_ico.png">
										</div>
										<ul class="nav-p1">

											<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_1_1)">
												<a href="" (click)="linkMap($event, 'OBJ_1_1')">
													<img src="{{imagePath}}p1_ico_e1.png" width="135px">
												</a>
											</li>
											<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_1_2)">
												<a href="" (click)="linkMap($event, 'OBJ_1_2')">
													<img src="{{imagePath}}p1_ico_e2.png" width="157px" style="margin-left: 20px">
												</a>
											</li>
											<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_1_3)">
												<a href="" (click)="linkMap($event, 'OBJ_1_3')">
													<img src="{{imagePath}}p1_ico_e3.png" width="295px" style="margin-left: 15px">
												</a>
											</li>
										</ul>
									</div>
									<div id="header_p2" class="header_p">
										<img src="{{imagePath}}header_p2.png" class="img-fluid">
									</div>
									<div class="content_p2 bg_content_p2">
										<div class="tarja-left-p2 bg_p2">
											<img src="{{imagePath}}target_ico.png">
										</div>
										<div style="padding-top: 10px;">
											<ul class="nav-p2 mg-15">
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_1)">
													<a href="" (click)="linkMap($event, 'OBJ_2_1')">
														<img src="{{imagePath}}p2_ico_e1.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_2)">
													<a href="" (click)="linkMap($event, 'OBJ_2_2')">
														<img src="{{imagePath}}p2_ico_e2.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_3)">
													<a href="" (click)="linkMap($event, 'OBJ_2_3')">
														<img src="{{imagePath}}p2_ico_e3.png"></a>
												</li>
											</ul>
											<ul class="nav-p2">
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_4)">
													<a href="" (click)="linkMap($event, 'OBJ_2_4')">
														<img src="{{imagePath}}p2_ico_e4.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_5)">
													<a href="" (click)="linkMap($event, 'OBJ_2_5')">
														<img src="{{imagePath}}p2_ico_e5.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_6)">
													<a href="" (click)="linkMap($event, 'OBJ_2_6')">
														<img src="{{imagePath}}p2_ico_e6.png">
													</a>
												</li>
											</ul>
										</div>
									</div>

									<div id="header_p3" class="header_p">
										<img src="{{imagePath}}header_p3.png" class="img-fluid">
									</div>
									<div class="content_p2 bg_content_p2">
										<div class="tarja-left-p2 bg_p2">
											<img src="{{imagePath}}target_ico.png">
										</div>
										<div style="padding-top: 10px;">
											<ul class="nav-p2 mg-15">
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_1)">
													<a href="" (click)="linkMap($event, 'OBJ_3_1')">
														<img src="{{imagePath}}p3_ico_e1.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_2)">
													<a href="" (click)="linkMap($event, 'OBJ_3_2')">
														<img src="{{imagePath}}p3_ico_e2.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_3)">
													<a href="" (click)="linkMap($event, 'OBJ_3_3')">
														<img src="{{imagePath}}p3_ico_e3.png">
													</a>
												</li>
											</ul>
											<ul class="nav-p2">
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_4)">
													<a href="" (click)="linkMap($event, 'OBJ_3_4')">
														<img src="{{imagePath}}p3_ico_e4.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_5)">
													<a href="" (click)="linkMap($event, 'OBJ_3_5')">
														<img src="{{imagePath}}p3_ico_e5.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_6)">
													<a href="" (click)="linkMap($event, 'OBJ_3_6')">
														<img src="{{imagePath}}p3_ico_e6.png">
													</a>
												</li>
											</ul>
										</div>
									</div>
									<div id="header_p4" class="header_p">
										<img src="{{imagePath}}header_p4.png" class="img-fluid">
									</div>
									<div class="content_p4 bg_content_p4">
										<div class="tarja-left-p4 bg_p4">
											<img src="{{imagePath}}target_ico.png">
										</div>
										<div style="padding-top: 8px;">
											<ul class="nav-p4">
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_1)">
													<a href="" (click)="linkMap($event, 'OBJ_4_1')">
														<img src="{{imagePath}}p4_ico_e1.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_2)">
													<a href="" (click)="linkMap($event, 'OBJ_4_2')">
														<img src="{{imagePath}}p4_ico_e2.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_3)">
													<a href="" (click)="linkMap($event, 'OBJ_4_3')">
														<img src="{{imagePath}}p4_ico_e3.png">
													</a>
												</li>
											</ul>
											<ul class="nav-p4-2">
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_4)">
													<a href="" (click)="linkMap($event, 'OBJ_4_4')">
														<img src="{{imagePath}}p4_ico_e4.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_5)">
													<a href="" (click)="linkMap($event, 'OBJ_4_5')" style="margin-left: 20px;">
														<img src="{{imagePath}}p4_ico_e5.png" style="margin-left: 10px;">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_6)">
													<a href="" (click)="linkMap($event, 'OBJ_4_6')" style="margin-left: 10px;">
														<img src="{{imagePath}}p4_ico_e6.png">
													</a>
												</li>
												<li *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_7)">
													<a href="" (click)="linkMap($event, 'OBJ_4_7')" style="margin-left: 15px;">
														<img src="{{imagePath}}p4_ico_e7.png">
													</a>
												</li>
											</ul>
										</div>
									</div>

								</div>
								<div id="col_left" class="col-md-5" style="position: absolute; top: 0; right: 0;">
									<div class="img-right">
										<img src="{{imagePath}}img-right.png">
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--minimal-->

					<div class="minimal-map-2023 ">
						<div class="row">
							<div class="col-md-2">
								<img class="img-fluid" width="200" src="{{imagePath}}logo_map_m_2.png">
							</div>
							<div class="col-md-10"></div>
						</div>

						<div class="row">
							<div class="col-12">
								<img class="img-fluid" src="{{imagePath}}logo_map_m_1.png">
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<img class="img-fluid" src="{{imagePath}}header_p1.png">
							</div>
						</div>
						<div class="row bg_content_p1 row-map-small">
							<div class="col-12 content_p_min ">
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_1_1)" href="" (click)="linkMap($event, 'OBJ_1_1')">
									<img class="img-fluid" src="{{imagePath}}p1_ico_e1.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_1_2)" href="" (click)="linkMap($event, 'OBJ_1_2')">
									<img class="img-fluid" src="{{imagePath}}p1_ico_e2.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_1_3)" href="" (click)="linkMap($event, 'OBJ_1_3')">
									<img class="img-fluid" src="{{imagePath}}p1_ico_e3.png">
								</a>
								<div class="col-2 tarja_min bg_p1" style="position: absolute; top: 0; left: 0;">
									<img src="{{imagePath}}target_ico.png">
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<img class="img-fluid" src="{{imagePath}}header_p2.png">
							</div>
						</div>
						<div class="row bg_content_p2 row-map-small">
							<div class="col-12 content_p_min ">
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_1)" href="" (click)="linkMap($event, 'OBJ_2_1')">
									<img class="img-fluid" src="{{imagePath}}p2_ico_e1.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_2)" href="" (click)="linkMap($event, 'OBJ_2_2')">
									<img class="img-fluid" src="{{imagePath}}p2_ico_e2.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_3)" href="" (click)="linkMap($event, 'OBJ_2_3')">
									<img class="img-fluid" src="{{imagePath}}p2_ico_e3.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_4)" href="" (click)="linkMap($event, 'OBJ_2_4')">
									<img class="img-fluid" src="{{imagePath}}p2_ico_e4.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_5)" href="" (click)="linkMap($event, 'OBJ_2_5')">
									<img class="img-fluid" src="{{imagePath}}p2_ico_e5.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_2_6)" href="" (click)="linkMap($event, 'OBJ_2_6')">
									<img class="img-fluid" src="{{imagePath}}p2_ico_e6.png">
								</a>
								<div class="col-2 tarja_min bg_p2" style="position: absolute; top: 0; left: 0;">
									<img src="{{imagePath}}target_ico.png">
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<img class="img-fluid" src="{{imagePath}}header_p3.png">
							</div>
						</div>
						<div class="row bg_content_p2 row-map-small">
							<div class="col-12 content_p_min ">
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_1)" href="" (click)="linkMap($event, 'OBJ_3_1')">
									<img class="img-fluid" src="{{imagePath}}p3_ico_e1.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_2)" href="" (click)="linkMap($event, 'OBJ_3_2')">
									<img class="img-fluid" src="{{imagePath}}p3_ico_e2.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_3)" href="" (click)="linkMap($event, 'OBJ_3_3')">
									<img class="img-fluid" src="{{imagePath}}p3_ico_e3.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_4)" href="" (click)="linkMap($event, 'OBJ_3_4')">
									<img class="img-fluid" src="{{imagePath}}p3_ico_e4.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_5)" href="" (click)="linkMap($event, 'OBJ_3_5')">
									<img class="img-fluid" src="{{imagePath}}p3_ico_e5.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_3_6)" href="" (click)="linkMap($event, 'OBJ_3_6')">
									<img class="img-fluid" src="{{imagePath}}p3_ico_e6.png">
								</a>
								<div class="col-2 tarja_min bg_p2" style="position: absolute; top: 0; left: 0;">
									<img src="{{imagePath}}target_ico.png">
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<img class="img-fluid" src="{{imagePath}}header_p4.png">
							</div>
						</div>
						<div class="row bg_content_p4 row-map-small">
							<div class="col-12 content_p_min ">
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_1)" href="" (click)="linkMap($event, 'OBJ_4_1')">
									<img class="img-fluid" src="{{imagePath}}p4_ico_e1.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_2)" href="" (click)="linkMap($event, 'OBJ_4_2')">
									<img class="img-fluid" src="{{imagePath}}p4_ico_e2.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_3)" href="" (click)="linkMap($event, 'OBJ_4_3')">
									<img class="img-fluid" src="{{imagePath}}p4_ico_e3.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_4)" href="" (click)="linkMap($event, 'OBJ_4_4')">
									<img class="img-fluid" src="{{imagePath}}p4_ico_e4.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_5)" href="" (click)="linkMap($event, 'OBJ_4_5')">
									<img class="img-fluid" src="{{imagePath}}p4_ico_e5.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_6)" href="" (click)="linkMap($event, 'OBJ_4_6')">
									<img class="img-fluid" src="{{imagePath}}p4_ico_e6.png">
								</a>
								<a *ngIf="projects === 'M1'|| verificaObjetivo(objs?.OBJ_4_7)" href="" (click)="linkMap($event, 'OBJ_4_7')">
									<img class="img-fluid" src="{{imagePath}}p4_ico_e7.png">
								</a>
								<div class="col-2 tarja_min bg_p4" style="position: absolute; top: 0; left: 0;">
									<img src="{{imagePath}}target_ico.png">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-loading [loader]="isLoading"></app-loading>
